import React from 'react'
import {selectUser} from '../../Redux/Reducer/userReducer'
import {selectChat} from '../../Redux/Reducer/chatReducer'
import { useSelector } from 'react-redux'
import {useEffect,useState,useRef} from 'react'
import './Chat.css'
// import './Chat.scss'
import newChatIcon from '../../Assets/newChat.png'
import upload from '../../Assets/upload.png'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faPenNib } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { useDispatch } from "react-redux"
// import {chat} from '../../reducers/chatReducer'
import {chat} from '../../Redux/Reducer/chatReducer'
import  {getChatHistory}  from '../../services/chatServices';
import  {getLLmOutput}  from '../../services/chatServices';
import { getChatData,renameChatTitle,deleteChatEndpoint,switchRole } from '../../services/chatServices';
// import NewChat from '../NewChat/NewChat'
import { updateChat,ChatID,ChatState,chatCountState } from '../../Redux/Actions'
import Group from '../../Assets/Group.png'
import edit from '../../Assets/edit.png'
import verticalDots from '../../Assets/verticalDots.png'
import {count1,setCount} from '../NewChat/NewChat'
import Avatar from '../../Assets/Avatar.png'
import { useNavigate } from "react-router-dom";
import rename from '../../Assets/rename.png';
import Delete from '../../Assets/delete.png';
import share from '../../Assets/share.png';
import logout from '../../Assets/logout.png';
import settings from '../../Assets/settings.png';
import user from '../../Assets/user1.png';
import featuredIcocn from '../../Assets/FeaturedIcon.png';
import feedback from '../../Assets/feedback.png';
import cross from '../../Assets/cross.svg';
import whiteCross from '../../Assets/cross.png';
import NewChat from '../NewChat/NewChat'; 
import line from '../../Assets/Line.png';
import openSidebar from '../../Assets/openSidebar.svg'
import closeSidebar from '../../Assets/closeSidebar.svg'
import open from '../../Assets/open.svg'
import close from '../../Assets/Close.svg'
// import {sideBar,setSidebar} from '../NewChat/NewChat'
// import { Popup } from "@progress/kendo-react-popup";
let count=0
let buttonClicked=false
// const [count1, setCount1] = useState(0);
const setClicked = (newValue) => 
  {
    buttonClicked = newValue;
  };

  export {buttonClicked,setClicked}


  // console.log(sideBar,'outside the component')
export default function Chat() {

  const flag = useSelector(state => state.userReducer)
  const chat = useSelector(state => state.chatReducer)

  const dispatch=useDispatch();
  const [showDiv, setShowDiv] = useState(false);
  const [showDiv1, setShowDiv1] = useState(true);
  const [Data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [chatData, setChatData] = useState([]);
  const chatDataId = useSelector(state => state.chatReducer)
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(null);
  const [inputValue1, setInputValue1] = useState('');
  const [disableInput, setDisableInput] = useState(false);
  const [recentChat, setRecentChat] = useState(true);
  const [titleRename, setrenameTitle] = useState(false);
  const [index1, setIndex1] = useState();
  const [popup,setPopup] = useState();
  const [confirmPopup,setConfirmPopup] = useState(false);
  const [logoutPopup,setLogoutPopup] = useState(false);
  const [roleState,setRoleState] = useState(false);
  const [chatIndex, setChatIndex] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [popupPosition1, setPopupPosition1] = useState({ top: 0, left: 0 });
  const navigate = useNavigate()
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [token, setToken] = useState('');
  const [triggerEffect, setTriggerEffect] = useState(false); // Add this state
  const [allowedRoles, setAllowedRoles] = useState([]); // Add this state
  
  let buttonClicked=false
  let flag1,index2,item1
  let chatData1
    setTimeout(() => {
  flag1=flag
},100)

const [isHovered, setIsHovered] = useState(false);
const [inputValue, setInputValue] = useState();
const [isOpen, setIsOpen] = useState(false);



const openPopup = (index,item,button) => {

  const buttonRect = button.target.getBoundingClientRect();
    setPopupPosition({
      top: buttonRect.top + 30,
      // left: buttonRect.left + window.scrollX-20,
    });
  setSelectedButtonIndex(index);
  setPopup(true)
  setIndex1(item)
 
};

const closePopup = () => {
  setSelectedButtonIndex(null);
  setPopup(false)
};

const closePopup1 = () => {
  setLogoutPopup(false)
};
const togglePopup = (index) => {
  setIsOpen(!isOpen);

  index2=index

  const data = {
    chat_id: chatData1[index].chat_id,
    // new_title: 
  }


}

const [chatCount, setChatCount] = useState(1);
  function loadChats(){
    setChatCount(chatCount + 1);
    console.log("load chat function is called")
  }

useEffect(() => {
  console.log("chatCount",chatCount)
  dispatch(chatCountState(chatCount))
},[chatCount])

useEffect(() => {

},[chat.chatHistoryState])

const [activeButtonIndex, setActiveButtonIndex] = useState(null);

const handleButtonClick2 = (index) => {
  setActiveButtonIndex(index);
  setIsHovered(false)
}

// setAllowedRoles(prev => [prev,localStorage.rolesAllowed])

const rolesString = localStorage.getItem('rolesAllowed');

// Split the string into an array
const rolesArray = rolesString.split(',');

// Now rolesArray will contain each role as an individual element

  const handleButtonClick = () => {
    chat.sidebarState = false
    setActiveButtonIndex(null)
    setCount(0)
    setClicked(false)
    buttonClicked = true
   
    setShowDiv(false);

    setTimeout(() => {
      setShowDiv(true);
    }, 100);
 
    setShowDiv1(false);

    dispatch(updateChat({}))
    setRecentChat(true)
    
    
      dispatch(ChatState(recentChat))
    // dispatch(ChatID(""))
   
  };

  const options = {
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ localStorage.token
    }
  };
  let monthArr=['January','December','November','October','September','August','July','June','May','April']

  useEffect(() => {
    
  }, [chatData,handleChange]);
  
  
    useEffect(() => {
      if(localStorage.userId){
        const data = {
          user_id: localStorage.userId
        };
          async function fetchChatHistory() {     
              // try {
              //     const response = await getChatHistory(data, options);
              //     setChatData(response);
                  
                  
              // } catch (error) {
              //     console.error("Error:", error);
                
              // }
              
              const baseUrl = process.env.REACT_APP_BASE_URL;
              try {
                const chatCountState = chat.chatCountState; // Get the value from chat
                const chatSize = chat.chatCountState * 15
                console.log("chatSize",chatSize)
                // useEffect(() => {
                  const response = await axios.post(`${baseUrl}/get_recent_chats?page=${chatCountState}&size=${chatSize}`, data, options);
                  console.log("response chat",response)
                  setChatData(response.data.chat_titles_by_month)
                // },[chatCountState])
               
                // const response = await axios.post(baseUrl+'/get_recent_chats?page=chat.chatCountState&size=5', data, options);             
                // return response.data.chat_titles_by_month;
            } catch (error) {
                console.error("Error:", error);
                throw error;
                }
          }
        
          // setTimeout(() => {
            fetchChatHistory();
          // }, 500);
      }
      
           
          
    }, [count1, chat.chatCountState]);

  
    async function getChat(chatId){
      const data = {
        user_id: localStorage.userId,
        chat_id: chatId
      };
    
      try {
        const response = await getChatData(data, options);
       
        
        dispatch(updateChat(response.data.chat_history))
        dispatch(ChatID(chatId))

        } catch (error) {
        console.error("Error:", error);
        }
    }
    
    

   function handleClick(chatId) {

    if(window.innerWidth <= 910){
      sidebarState()
    }
    
    let chatData2=chatData
      // let chatId=chatData1[index].chat_id
      getChat(chatId)
      setRecentChat(false)
      dispatch(ChatState(true))

      setTimeout(() => {
        dispatch(ChatState(false))

      }, 200);

      setTriggerEffect((prev) => !prev);

      setClicked(true)

    }

    function renameTitle(){
      
      
      setrenameTitle(true)
      setPopup(false)
      setChatIndex(selectedButtonIndex)
     
    }


    const handleButtonClick1 = () => {
     
      if (inputValue === 'disable') {
        setDisableInput(true);
      } else {
        setDisableInput(false);
      }
  
    };

    const handleInputChange = (event) => {
      setInputValue(event.target.value);
    };

    
    function handleChange(input) {
      // event.preventDefault();
        const data = {
          chat_id: index1.chat_id,
          new_chat_title: input
        };
    
        try {
          renameChatTitle(data, options);
          // setChatIndex(null);

          setrenameTitle(false)
        let array = chatData['May'].map(item => {
          if (item.chat_id === index1.chat_id) {
            item.chat_title=document.getElementById('user-input').value;
          }
           return item;
        });


        } catch (error) {
          console.error("Error:", error);
        }
       
    }
 
   async function deleteChat(){
      const data = {
        chat_id: index1.chat_id,
      };
  
      try {

        let response=await deleteChatEndpoint(data, options);

        setPopup(false)
        setConfirmPopup(true)

        setTimeout(() => {
          setConfirmPopup(false)
        }, 2000);


        const data1 = {
        user_id: localStorage.userId
      };
     
      for (let i = 0; i < monthArr.length; i++) {
        const month = monthArr[i];

        if(chatData[month]){
        const updatedArray = chatData[month].filter(item => item.chat_id !== index1.chat_id);
        
        setChatData(prevChatData => ({
          ...prevChatData,
          [month]: updatedArray
        }));
      }
      }

      } catch (error) {
        console.error("Error:", error);
      }
    }

    function outPopup(button){
      const buttonRect = button.getBoundingClientRect();
    setPopupPosition1({
      top: buttonRect.top - 200,
      // left: buttonRect.left + window.scrollX,
    });
      setLogoutPopup(!logoutPopup)
    }

    function logOut(){

      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      navigate('/')

    }

    function onKeyPressHandler (e) {
      e.preventDefault();
      if (e.key === 'Enter') {
        const data = {
          chat_id: index1.chat_id,
          new_chat_title: e.target.value
        };
    
        try {
          renameChatTitle(data, options);
          // setChatIndex(null);

          setrenameTitle(false)

        let found = false;

        for (let i = 0; i < monthArr.length; i++) {
          const month = monthArr[i];
          const monthArray = chatData[month];
        
          if(chatData[month]){
            for(let j=0;j<monthArray.length;j++){
              if(chatData[month][j].chat_id==index1.chat_id){
                chatData[month][j].chat_title=e.target.value
              }
            }          
          }
        }

        } catch (error) {
          console.error("Error:", error);
        }
      }
  }

  function capitalizeWords(string) {
    return string.split(' ').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
}
  const [selectedRole, setSelectedRole] = useState(''); // Default value
  function roleChange(){
    setRoleState(true)
  }
  
  function cancelRole(){
    setRoleState(false)
  }

  async function roleSwitch(){
    let role=selectedRole.toUpperCase();
    let response = await switchRole(role);
    localStorage.setItem('role', response.user.activeRole);
    // localStorage.setItem('token', response.token);
   
    if(response){
      setRoleState(false)
    }
  }


  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  useEffect(() => {
    setLogoutPopup(false)
  },[roleState])

useEffect(()=>{
  console.log("window.width",window.innerWidth)
},[window.innerWidth])
  
useEffect(()=>{
  console.log("chat.sidebarState1",chat.sidebarState)
},[chat.sidebarState])

function sidebarState(){
  chat.sidebarState = false
  setIsHovered(false)
  console.log("chat.sidebarState",chat.sidebarState)
}
  return (
   
    <>

      <div className="row">
      {/* <img src={edit} style={{width: '20px',height: '20px',float: 'right',marginLeft:'auto',marginTop: '-4px'}}/> */}
        {/* <div className="col-8"> */}
        {chat.sidebarState && (
            <div className={`sidebar1 ${window.innerWidth <= 910 ? 'col-7' : 'col-2'}`} >
      
            <div style={{alignItems:'left',paddingTop:'0.625rem',marginLeft:'0.406rem',cursor: 'pointer'}}>
                <div className='inner-div' onClick={handleButtonClick}>
                    <img src={Group} className='groupIcon'/>
                    <span className='newChat'>New Chat</span>
                    <img src={edit} className='editIcon'/>
                </div>
    
            </div>

           {window.innerWidth <= 910 && (
            //    <div className='lineBar' onClick={closeSidebar}>
            //    <img 
            //      src={line}
            //            // className={`w3 ${chat.sidebarState ? 'lineImg' : 'lineImg1'}`}
            //    />
            //  </div>

            <div 
                  className={`lineBar ${isHovered ? 'hovered' : ''}`} 
                  style={{marginLeft: isHovered ? window.innerWidth <= 600 ?'73%':'84%':'86%' }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >

                  {isHovered ? (
                    <>
                        <>
                          <img src={close} className="w11" onClick={sidebarState} />
                          <img src={closeSidebar} className="w2" onClick={sidebarState} />
                        </>
                     
                    </>
                  ) : (
                    <img src={line} className={`w3 ${chat.sidebarState ? 'lineImg' : 'lineImg1'}`} />
                   )} 
                </div>

           )}
           
    
              <div className="scrollable-content1" >
                { popup==true && (
                    <div >
                        <div className="popup" style={{top: popupPosition.top}}>
                      <div className="popup-content">
                      
                            <span style={{float:'right'}} onClick={closePopup}>
                              <img src={whiteCross} style={{width: '1.125rem',height: '1.125rem',padding: '1.88px 1.88px 2px 2px',float: 'left',
                                    }}/>
                            </span>
                            <br/>
                            <div type='' className='popup1-button'>
                                <span style={{paddingLeft:'0.313rem',paddingRight:'0.313rem',paddingTop:'0.313rem'}}>
                                  <img src={share} className='popupIcon'/>
                                </span>
                                
                                <span className='text' style={{font:'Poppins',weight:'500',size:'0.875rem',color:'#F0F5FF'}}>Share</span>
                            </div>
    
                            <div type="" className='popup1-button' onClick={renameTitle}>
                                <span style={{paddingLeft:'0.313rem',paddingRight:'0.313rem',paddingTop:'0.313rem'}}>
                                  <img src={rename} className='popupIcon'/>
                                </span>
                                
                                <span className='text' style={{font:'Poppins',weight:'500',size:'0.875rem',color:'#F0F5FF'}}>Rename</span>
                            </div>
                            <div className="line"></div>
    
                            <div type='' className='popup1-button' onClick={deleteChat}>
                                <span style={{paddingLeft:'0.313rem',paddingRight:'0.313rem',paddingTop:'0.313rem'}}>
                                  <img src={Delete} className='popupIcon'/>
                                </span>
                                
                                <span className='text' style={{font:'Poppins',weight:'500',size:'0.875rem',color:'#F0F5FF'}}>Delete Chat</span>
                            </div>
                      
                      </div>
                    </div>
                    </div>
                    
                  )}
    
                  {confirmPopup && (
                      <div >
                      <div className="popup2" style={{top: popupPosition.top}}>
                    <div className="popup-content2">
                    
                          <br/>

                          <span  style={{font:'Poppins',fontWeight:'bold',fontSize:'1rem',color:'#F0F5FF'}}>Chat deleted successfully</span>
                         
                    
                    </div>
                  </div>
                  </div>
                  )}
    
                      <div style={{marginLeft:'1.375rem'}}>
                        {monthArr.map((month, monthIndex) => (
                          <div key={monthIndex}>
                            {chatData[month] && (
                              <div style={{ textAlign: 'left', fontFamily: 'Poppins', fontSize: '0.875rem', fontWeight: '600', color: '#B1D5EC', marginLeft: '2rem', marginTop: '1.5rem', paddingBottom: '0.438rem' }}>
                                {month}
                              </div>
                            )}
    
                            {chatData[month] && chatData[month].map((item, index) => (
                             <div className="button2"  style={{ position: 'relative',backgroundColor: activeButtonIndex == index ? '#045E98':'' }}>
                             {(selectedButtonIndex === index && titleRename) ? (
                               <form onSubmit={e => e.preventDefault()}>
                                 <input
                                   type="text"
                                   id="user-input"
                                   defaultValue={chatData[month][index].chat_title}
                                   onKeyUp={(e) => onKeyPressHandler(e)}
                                   style={{
                                     fontFamily: 'Poppins', fontSize: '1rem', fontWeight: '500',
                                     textAlign: 'left', color: '#F0F5FF', float: 'left', background: '#045E98',
                                     width: '80%'
                                   }}
                                   
                                 />
                               </form>
                             ) : (
                               <span className='truncate chatText' 
                               onClick={() => {
                                handleClick(item.chat_id);
                                handleButtonClick2(index); // Change color on click
                              }} 
                                key={index}>
                                 {chatData[month][index].chat_title}
                               </span>
                             )}
                           
                             {/* Dots Icon */}
                             <div className="dots-icon" onClick={(e) => openPopup(index, item, e)}>
                               <img src={verticalDots} alt="Dots Icon" />
                             </div>
                           </div>
                           
                            ))}
                          </div>
                        ))}

                        
                  </div>
    
                
              </div>
      
              { logoutPopup==true && (
                    <div style={{paddingLeft:'0.625rem'}}>
                        <div className="popup1" style={{top: popupPosition1.top, paddingLeft: '0.4rem'}}>
                      <div className="popup-content">
                      
                          <span style={{float:'right'}} onClick={closePopup1}>
                              <img src={whiteCross} style={{width: '1.125rem',height: '1.125rem',padding: '1.88px 1.88px 2px 2px',float: 'left',
                                    }}/>
                            </span>
                            <br/>
    
                            <div style={{fontFamily: 'Poppins',color: '#FFFF',fontSize: '0.938rem',border:'none',height:'2.5rem'}}>
                                <span className='popup1-text'>{localStorage.email}
                                </span>
                            </div>
                            <div className="line"></div>
                            {/* <hr/> */}
    
                            <div type='' className='popup1-button'>
                                <span style={{paddingLeft:'0.313rem',paddingRight:'0.313rem'}}>
                                  <img src={settings} className='popupIcon'/>
                                </span>
                                
                                <span className='popup1-text'>Settings</span>
                            </div>

                            <div type='' className='popup1-button' onClick={roleChange}>
                                <span style={{paddingLeft:'0.313rem',paddingRight:'0.313rem'}}>
                                  <img src={user} className='popupIcon'/>
                                </span>
                                
                                <span className='popup1-text'>Role: {localStorage.role}</span>
                            </div>
    
                            <div type='' className='popup1-button'>
                                <span style={{paddingLeft:'0.313rem',paddingRight:'0.313rem'}}>
                                  <img src={feedback} className='popupIcon'/>
                                </span>
                                
                                <span className='popup1-text'>Submit Feedback</span>
                            </div>
                            {/* <hr/> */}
                            <div className="line"></div>
    
                            <div type='' className='popup1-button' onClick={logOut}>
                                <span style={{paddingLeft:'0.313rem',paddingRight:'0.313rem'}}>
                                  <img src={logout} className='popupIcon'/>
                                </span>
                                
                                <span className='popup1-text'>Logout</span>
                            </div>

                            
    
                        {/* <button className="close-btn">
                          Close
                        </button> */}
                      </div>
                    </div>
                    </div>
                    
                  )}
    
                {roleState == true && (
                <div className="popupOverlay">
                <div className="popupRole" style={{ paddingLeft: '0.4rem' }}>
                  <div className="popup-content">
                    <div style={{marginLeft:'2rem'}}>
                    <div style={{width:'48px',height:'48px'}}>
                      <img src={featuredIcocn} alt="Dots Icon" />
                    </div>

                    <div style={{ fontSize:'18px', fontWeight:'600', color:'#101828', marginTop:'29px',fontFamily:'Poppins'}}>
                      <span>Change User Role</span>
                    </div>

                    <div style={{ fontSize:'14px', color:'#667085', marginTop:'21px',fontFamily:'Poppins'}}>
                      <span>PLease select the role that you need to change</span>
                    </div>

                    <div style={{ fontSize:'14px', color:'#101828', marginTop:'16px', fontFamily:'Poppins'}}>
                      <span>Select Role</span>
                    </div>

                  
                      <select id="role" name="role" value={selectedRole} onChange={handleRoleChange}>

                          {rolesArray.map(role => (
                              <option key={role} value={role}>
                                          {role}
                                </option>
                                  ))}
                        
                      </select>

                      <div className='row' style={{marginTop:'20px', marginLeft: '1rem'}}>
                        <div className='col-5 buttonRole' onClick={cancelRole}>
                          Cancel
                        </div>
                        &nbsp; &nbsp;
                        <div className='col-5 buttonRole1' onClick={roleSwitch}>
                          Update
                        </div>
                          
                      </div>
                    </div>
              
                  </div>
                </div>
              </div>
              
                )}

                {/* load more button */}
              
                <div className="bottom-content1">
                  {/* load more button */}
                  {/* <div className={`bottom-content1-button1`} onClick={loadChats}>
                    <div className="info">
                      <span className='name1'>
                        Load more ...
                      </span>
                    
                    </div>
                    
                  </div> */}

                  <div className={`bottom-content1-button ${logoutPopup ? 'active' : ''}`} onClick={(e) => outPopup(e.target)} style={{marginTop:'2rem'}}
                  >
                    <img src={Avatar} alt="Avatar" />
                    <div className="info">
                      <span className='name'>
                        {localStorage.name} {localStorage.lastName}
                      </span>
                      <span className="role">
                        {localStorage.role}
                      </span>
                    </div>
                    
                    <img
                      src={verticalDots}
                      alt="Vertical Dots"
                      className="dots"
                      
                    />
                  </div>
                </div>
    
            </div>
        )}
        
        {/* <img src={edit} style={{width: '20px',height: '20px',float: 'right',marginLeft:'auto',marginTop: '-4px'}}/> */}
        {/* </div> */}
        
          <div className={` ${chat.sidebarState ? 'col-10' : 'col-12'}`} style={{overflow:'hidden'}}>
            {showDiv && 
              <div style={{width:'100%',height:'100%',backgroundColor: 'white'}}>
                <NewChat recentChat={recentChat} triggerEffect={triggerEffect}/>
               </div>  
              }

            {showDiv1 && 
              <div style={{width:'100%',height:'100%',backgroundColor: 'white'}}>
                <NewChat recentChat={recentChat} triggerEffect={triggerEffect}/>
                </div>
            }    
          </div>
        </div>

    </>
    
  )
}

